import type {
	APIWithPagination,
	QueryParams,
	SWRConfigInterface,
} from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useWPApi } from "@gik/core/api/swr/useWPApi";
import { apiCap } from ".";

const PATH = "employee";

export interface Employee {
	id: number;
	name: string;
	title: string;
	titleAlt?: string;
	photo?: string;
	photoAlt?: string;
	order: number;
}

export interface WPEmployee {
	id: number;
	title: {
		rendered: string;
	};
	acf: {
		employee_type: string;
		photo_alt?: string;
		photo_main: string;
		title: string;
		title_copy_alt?: string;
		sort_order: number;
	};
}

export type EmployeesParams = {} & APIWithPagination;

export type EmployeesTransformed = {
	employees: Employee[];
};

function getParams(params: EmployeesParams): QueryParams {
	return {
		perPage: apiCap,
		...params,
		_fields: ["acf", "title", "id"],
	};
}

export const mapToEmployee = (employee: WPEmployee): Employee => ({
	id: employee.id,
	name: employee.title.rendered,
	title: employee.acf.title,
	titleAlt: employee.acf.title_copy_alt,
	photo: employee.acf.photo_main,
	photoAlt: employee.acf.photo_alt,
	order: employee.acf.sort_order,
});

export async function getEmployees(params?: EmployeesParams) {
	return wpApi
		.get(PATH, {
			searchParams: getParams(params),
		})
		.json<[WPEmployee[], Employee[]]>();
}

export function useEmployees(
	params?: EmployeesParams,
	config?: SWRConfigInterface,
) {
	return useWPApi<WPEmployee[]>(PATH, getParams(params), config);
}
